import styled from 'styled-components';

export const EditWebhookForm = styled.div<{ useFullWidth: boolean }>`
  width: ${(props) => (props.useFullWidth ? '100%' : '60%')};
`;
